import React from 'react';
import styles from './styles.module.scss';

type ButtonVariant = 'primary' | 'secondary';

type Props = {
  title: string;
  variant?: ButtonVariant;
  href: string;
  fz?: string;
};

const Button: React.FC<Props> = ({ title, variant = 'primary', href, fz }) => {
  return (
    <a href={href} className={`${styles.button} ${styles[`button--${variant}`]}`}>
      <span className={styles.button__text} style={{ fontSize: fz }}>
        {title}
      </span>
      <div className={styles.button__arrow}>
        <svg
          width="13"
          height="8"
          viewBox="0 0 13 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0.559082 4.00781H12.0291" stroke="currentColor" strokeLinecap="round" />
          <path d="M8.32422 0.707031L12.4419 4.00115" stroke="currentColor" strokeLinecap="round" />
          <path d="M8.32422 7.30193L12.4419 4.00781" stroke="currentColor" strokeLinecap="round" />
        </svg>
      </div>
    </a>
  );
};

export default Button;
